import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";
import dayjs from "dayjs";

import authBackground from "assets/images/auth-bg.png";
import { ReactComponent as LetterLogo } from "assets/letter-logo.svg";
import { DesktopLogo } from "components/SVGIcons";
import { routes } from "constants/routes";
import useDeviceType from "hooks/useDeviceType";
import styles from "./style.module.scss";

interface IProps {
  header?: React.ReactNode;
  children?: React.ReactNode;
  size?: "sm" | "lg";
  headerClass?: string;
  className?: string;
}

export default function AuthLayout({
  header,
  children,
  size = "sm",
  headerClass,
  className
}: Readonly<IProps>) {
  const currentYear = dayjs().year();
  const { isDesktop } = useDeviceType();
  const location = useLocation();

  return (
    <div className={clsx(styles.authPage, "no-safe-area")}>
      {!isDesktop && (
        <img src={authBackground} alt="auth background" className={styles.authBackgroundMobile} />
      )}

      <div
        className={clsx(
          styles.authHeader,
          size === "lg" ? "desktop:max-w-7xl" : "desktop:max-w-2xl",
          { "mobile:!flex-1": !location.pathname.includes("signup") }
        )}>
        <div className={styles.headerBackdrop}></div>

        <div className={clsx(styles.headerWrapper, headerClass)}>
          <Link to={routes.SIGNIN}>
            <DesktopLogo className={styles.desktopLogo} />
          </Link>

          <Link to={routes.SIGNIN}>
            <LetterLogo className={styles.textLogo} />
          </Link>
          <span className={styles.subtitle}>Digital Freight Finance & Load Tech</span>

          {header}
        </div>

        {isDesktop && (
          <div
            className={clsx(
              styles.authDesktopContainer,
              className,
              size === "lg" ? "desktop:w-1/2" : "desktop:pr-40"
            )}>
            {children}
          </div>
        )}

        <p className={styles.description}>&copy; {currentYear} HaulPay | All Rights Reserved</p>
      </div>

      {isDesktop && (
        <img
          src={authBackground}
          alt="auth background"
          style={{
            maxWidth: size === "lg" ? "calc(100% - 80rem)" : "calc(100% - 42rem)",
            objectFit: "cover"
          }}
        />
      )}

      {!isDesktop && <div className={clsx(styles.authContainer, className)}>{children}</div>}
    </div>
  );
}
